import ReactDOM from 'react-dom'
import React from 'react'

type ModalPortalProps = {
    children: React.ReactNode
}

const modalRoot = document.getElementById('zr_customizer_root')

const ModalPortal = ({ children }: ModalPortalProps) => {
    if (!modalRoot) return null

    return ReactDOM.createPortal(children, modalRoot)
}

export default ModalPortal
